import { gql } from '@apollo/client';

const UPDATE_USER_JOB_TITLE = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfileV2(input: $input) {
      personalInfo {
        professionalInfo {
          jobTitle
          additionalProfessionalInfo {
            roleId
          }
        }
      }
    }
  }
`;

export default UPDATE_USER_JOB_TITLE;
